import { useState, useEffect } from 'react';

/**
 * Custom hook to handle scroll behavior and header visibility
 * Consolidates 2 useEffect hooks for scroll detection
 */
export const useScrollBehavior = () => {
  const [scrolled, setScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isScrollingUp, setIsScrollingUp] = useState(true);

  // Track general scroll state (scrolled or at top)
  useEffect(() => {
    const listenScrollEvent = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', listenScrollEvent);
    
    return () => {
      window.removeEventListener('scroll', listenScrollEvent);
    };
  }, []);

  // Track scroll direction (up or down)
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        setIsScrollingUp(false); // Scrolling down
      } else {
        setIsScrollingUp(true); // Scrolling up
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return {
    scrolled,
    isScrollingUp
  };
};

